export default function Loader({ loaded, loadPct, loadName, logoSrc }) {
  return (
    <div id="loader" className={loaded ? "out" : ""}>
      <img src={logoSrc} alt="HOGC" className="hogc-logo" width="160" height="160" style={{ width: 160, height: 160, marginBottom: 6, objectFit: "contain" }} />
      <div className="ld-track">
        <div className="ld-fill" style={{ width: `${loadPct}%` }} />
      </div>
      <div className="ld-pct">{loadPct}%</div>
      <div className="ld-name">{loadName}</div>
    </div>
  );
}
